/** Re-export del canónico: enteros `$1.500`, centavos `$1.316,70`, negativos `-$1.500`. */
export { formatMoney } from '../../../shared/format/public-api';
